export default __webpack_public_path__ + "static/media/profile-pic.b029ec47.jpg";